module.exports = __webpack_public_path__ + "static/media/TED-Masterclass-logo.a40c484e.svg";